/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Ai_Chat_Approval_DeclineInputs */

const en_admin_ai_chat_approval_decline = /** @type {(inputs: Admin_Ai_Chat_Approval_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Don't allow`)
};

const de_admin_ai_chat_approval_decline = /** @type {(inputs: Admin_Ai_Chat_Approval_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht erlauben`)
};

const es_admin_ai_chat_approval_decline = /** @type {(inputs: Admin_Ai_Chat_Approval_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No permitir`)
};

const fr_admin_ai_chat_approval_decline = /** @type {(inputs: Admin_Ai_Chat_Approval_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne pas autoriser`)
};

const nl_admin_ai_chat_approval_decline = /** @type {(inputs: Admin_Ai_Chat_Approval_DeclineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niet toestaan`)
};

/** @type {(inputs: Admin_Ai_Chat_Approval_DeclineInputs) => LocalizedString} */
const it_admin_ai_chat_approval_decline = en_admin_ai_chat_approval_decline;

/** @type {(inputs: Admin_Ai_Chat_Approval_DeclineInputs) => LocalizedString} */
const pt_br2_admin_ai_chat_approval_decline = en_admin_ai_chat_approval_decline;

/** @type {(inputs: Admin_Ai_Chat_Approval_DeclineInputs) => LocalizedString} */
const pl_admin_ai_chat_approval_decline = en_admin_ai_chat_approval_decline;

/** @type {(inputs: Admin_Ai_Chat_Approval_DeclineInputs) => LocalizedString} */
const hu_admin_ai_chat_approval_decline = en_admin_ai_chat_approval_decline;

/** @type {(inputs: Admin_Ai_Chat_Approval_DeclineInputs) => LocalizedString} */
const ro_admin_ai_chat_approval_decline = en_admin_ai_chat_approval_decline;

/**
* | output |
* | --- |
* | "Don't allow" |
*
* @param {Admin_Ai_Chat_Approval_DeclineInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_ai_chat_approval_decline = /** @type {((inputs?: Admin_Ai_Chat_Approval_DeclineInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Ai_Chat_Approval_DeclineInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_ai_chat_approval_decline(inputs)
	if (locale === "de") return de_admin_ai_chat_approval_decline(inputs)
	if (locale === "es") return es_admin_ai_chat_approval_decline(inputs)
	if (locale === "fr") return fr_admin_ai_chat_approval_decline(inputs)
	if (locale === "nl") return nl_admin_ai_chat_approval_decline(inputs)
	if (locale === "it") return it_admin_ai_chat_approval_decline(inputs)
	if (locale === "pt-BR") return pt_br2_admin_ai_chat_approval_decline(inputs)
	if (locale === "pl") return pl_admin_ai_chat_approval_decline(inputs)
	if (locale === "hu") return hu_admin_ai_chat_approval_decline(inputs)
	return ro_admin_ai_chat_approval_decline(inputs)
});
export { admin_ai_chat_approval_decline as "admin.ai_chat.approval_decline" }